import { ONECLUB_URL } from '@/constants/url'
import { getLocalLang, stringifyQuery, windowOpen } from '@/utils'
import { countryConfig } from './countryVersion'
import Cookies from 'js-cookie'

export const paramKey = ['ticket', 'loginCode']

export const OneClubPathMap = {
  login: '/user/login',
  resetPwd: '/user/changePassword',
}

/**
 * 优先从链接上取adminTicket，否则从localStorage取
 * @returns
 */
function getAdminTicket() {
  return new URL(location.href).searchParams.get('adminTicket') || Cookies.get('authorization')
}

/**
 *
 * @param path 路径
 * @param scene 退出场景
 * @param extraQuery 其他query查询参数
 * @returns
 */
export function getOneClubUrl(path: string, scene?: string, extraQuery?: Record<string, any>) {
  const language = getLocalLang()
  const domain = process.env.ONECLUB_URL || 'https://accounts.oneclub.vip'
  let service = window.location.href
  // 通知中心页面固定返回dashboard
  const isDashboard = ['home/noticeCenter', 'home/noticeCenter'].find((item) => service.includes(item))

  if (scene === 'error' || scene === 'user' || isDashboard) {
    service = `${window.location.origin}/dashboard`
  }

  const authorization = getAdminTicket()
  if (authorization) {
    const newUrl = new URL(service)
    newUrl.searchParams.append('adminTicket', authorization)
    service = newUrl.href
  }

  const url = stringifyQuery(domain + path, {
    ...extraQuery,
    app: countryConfig?.account_appId || 'os',
    lang: language?.[0]?.lang,
    service: encodeURIComponent(service),
    ...(['logout', 'error'].includes(scene) && {
      // 退出oneclub账号
      scene: 'logout',
    }),
  })
  return url
}

/**
 * 跳转到oneClub登录
 * @param args
 */
export function hrefToOneClubUrl(...args: Parameters<typeof getOneClubUrl>) {
  const url = getOneClubUrl(...args)
  Cookies.remove('authorization')
  window.location.href = url
}
/**
 * 跳转到oneClub登录(使用replace)
 * @param args
 */
export function replaceToOneClubUrl(...args: Parameters<typeof getOneClubUrl>) {
  const url = getOneClubUrl(...args)
  Cookies.remove('authorization')
  window.location.replace(url)
}

/**
 * 超管登录商家
 * 对于前端来讲就相对于是商家自己登录，除了cookie里面的uid是超管的
 */
export function adminLogin() {
  const url = new URL(window.location.href)
  const adminTicket = url.searchParams.get('adminTicket')
  if (!adminTicket) return
  url.searchParams.delete('adminTicket')
  window.history.replaceState(null, null, url)
  Cookies.set('authorization', adminTicket)
}

/**
 * 跳转到oneclub，携带adminTicket和lang
 * @param key
 * @param replace
 */
export function jumpToOneclub(key: keyof typeof ONECLUB_URL, replace?: boolean) {
  let link = ONECLUB_URL[key]
  const url = new URL(link)

  const authorization = getAdminTicket()
  if (authorization) url.searchParams.append('adminTicket', authorization)

  const language = getLocalLang()
  url.searchParams.append('lang', language?.[0]?.lang)

  link = url.href
  return replace ? window.location.replace(link) : windowOpen(link)
}
